import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../shared/http-client';
import dayjs from 'dayjs';

export const RenderFilters = ({ filters, vehicles, drivers }: { filters: any, vehicles?: any[], drivers?: any[] }) => {
    const { t } = useTranslation();
    const { api, state } = useHttpClient();


/*     useEffect(() => {
        api('/brands/?limit=9999', 'GET');
    }, []);
 */
    const renderFilters = (filters: any) => {
        let filtros = "<div class='flex'>";
        for (const key in filters) {
            if (key == 'is_preferred'|| key == 'is_complete' || key == 'is_validated_by_accounting' || key == 'is_delivered' || key == 'is_invoiced' || key == 'is_validated' || key == 'available' || key == 'is_purchase' || key == 'is_sale') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key] == 'true' ?  t('common.label.yes') : t('common.label.no')} |
                </div>`;
            }else if (key == 'timestamp_after' || key == 'timestamp_before' || key == 'order_date_after' || key == 'order_date_before' || key == 'requested_delivery_date_after' || key == 'requested_delivery_date_before' || key == 'actual_delivery_date_after' || key == 'actual_delivery_date_before' || key == 'expected_delivery_date_after' || key == 'expected_delivery_date_before') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${dayjs(filters[key]).format(
                    'DD-MM-YYYY'
                )} |
                </div>`;
            }
           /*  else if (key == 'item' || key == 'location' || key == 'customer') {
                filtros += `
                <div class='text-sm'>
                    
                </div>`;
            } */
             else if (key == 'reference') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key].reference} |
                </div>`;
            }
             else if (key == 'location') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key].code} |
                </div>`;
            }
             else if (key == 'customer') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key].name} |
                </div>`;
            }
             else if (key == 'requested_warehouse') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key].name} |
                </div>`;
            }
             else if (key == 'requesting_warehouse') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key].name} |
                </div>`;
            }
             else if (key == 'departure_location') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key].code} |
                </div>`;
            }
             else if (key == 'destination_location') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key].code} |
                </div>`;
            }
             else if (key == 'source_location') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key].code} |
                </div>`;
            }
            /* if (key == 'date_time_after' || key == 'date_time_before' || key == 'record_time_after' || key == 'record_time_before') {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${dayjs(filters[key]).format(
                    'DD-MM-YYYY'
                )} |
                </div>`;
            } else if (key == 'brand') {
                let brand = brands.find((value: any) => filters[key] === value.id);
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${brand?.name} |
                </div>`;

            } */ else if (key === 'vehicle' && vehicles) {
                const vehicle = vehicles.find(v => v.id === filters[key]);
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${vehicle ? vehicle.plate : filters[key]} |
                </div>`;
            } else if (key === 'driver' && drivers) {
                const driver = drivers.find(v => v.id === filters[key]);
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${driver ? driver.full_name : filters[key]} |
                </div>`;
            } else {
                filtros += `
                <div class='text-sm'>
                    <span class="text-gray-500 text-sm">&nbsp;${t(key)}</span>: ${filters[key]} |
                </div>`;
            }

        }
        filtros += "</div>";
        return { __html: filtros };
    }

    useEffect(() => {
        if (state.data) {
           /*  if (state.path.includes('brands')) {
                setBrands(state.data.results);
                api('/models/?limit=9999', 'GET');

            }
            if (state.path.includes('models')) {
                setModels(state.data.results);
                api('/areas/?limit=9999', 'GET');

            }
            if (state.path.includes('areas')) {
                setAreas(state.data.results);
                api('/identification_document_types/?limit=9999', 'GET');
            }
            if (state.path.includes('identification_document_types')) {
                setIdDocuments(state.data.results);
              
            } */
        }

    }, [state]);

    return (
        <div className={"py-4 flex"}>
            <div className={"text-sm font-bold"}>{t('common.label.filtros')}</div>
            {<div dangerouslySetInnerHTML={renderFilters(filters)} />}
        </div>
    )
};
